"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleFromUrl = exports.getLocaleFromSearchParams = void 0;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const getLocaleFromSearchParams = (searchParams) => {
    if (searchParams.has(constants_1.LANG_PARAM) && (0, utils_1.isSupportedLocale)(searchParams.get(constants_1.LANG_PARAM) || "")) {
        return (0, utils_1.getLocale)(searchParams.get(constants_1.LANG_PARAM));
    }
    return null;
};
exports.getLocaleFromSearchParams = getLocaleFromSearchParams;
const getLocaleFromUrl = (url) => {
    return (0, exports.getLocaleFromSearchParams)(url.searchParams);
};
exports.getLocaleFromUrl = getLocaleFromUrl;
//# sourceMappingURL=url.js.map